<template>
    <div class="wrap"
         v-bind:class="{
        }"
    >
        <header class="lnbWrap">
            <div class="logo">
                <h1 id="logo">
                    <template
                    >
                        <router-link to="/" title="" >
                            <img :src="SiteLogo.url" class="logImg" style="width:140px;"/>
                        </router-link>
                    </template>
                </h1>
            </div>
            <div class="lnbMenu">
                <nav class="nav_menu">

                    <ul class="lnb" id="lnbBox">
                        <sidebar-menu :menu="menuItem" :width="'210px'" />
                    </ul>
                </nav>
            </div>
        </header>
        <div class="container lnb">
            <div class="header">
                <div class="h_left">
<!--                 일대일 문의 api 아직 -->
                    <div class="h_alarm" v-if="qnaCount != ''">
                      <span>{{ qnaCount }}</span>개의 미답변 문의가 있습니다.
                    </div>

                    <div class="menu_notice">
                        <el-carousel height="70px" direction="vertical" :autoplay="true" :interval="10000">
                            <el-carousel-item v-for="notice in NoticeList" :key="notice.wr_id">
                                <h3 class="medium">{{ notice.wr_subject }}</h3>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
                <div class="h_right util cursor logout_btn header_avatar">
                    <img v-if="!UserInfo && UserInfo.hasOwnProperty('File') && UserInfo.File.hasOwnProperty('0')" :src="UserInfo.File.thumb_url" alt="">
                    <img v-else src="@/assets/image/common/mypage.png" alt="">
                </div>
                <div class="h_right util cursor logout_btn" @click="logout">
                    <img src="@/assets/image/common/logout.png" alt="">
                </div>
            </div>
        </div>

    </div>
</template>


<script>
    import localStorage from '@/mixins/localStorage'
    import VuxAlert from '@/mixins/alertMixins';
    import Swal from 'sweetalert2'
    import { SidebarMenu } from 'vue-sidebar-menu'
    import setMenu from "@/mixins/setMenu";
    import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
    // import userInfo from '@/mixins/userInfo';
    import siteInfo from '@/mixins/siteInfo';
    import EventBus from "@/mixins/event-bus";
    export default {
        name: "PageHeader",
        mixins: [ localStorage, VuxAlert, setMenu , siteInfo],
        components: {
            SidebarMenu
        },
        data(){
            return{
                lnbStatus : true,
                sideList: this.$router.options.routes,
                level: 0,
                File: {},
                NoticeList: [],
                qnaCount: '',
            }
        },
        created() {
        },
        computed: {
            metaName(){
                return this.$route.meta.title
            },
        },
        mounted() {
          this.getQaAlarm();
          EventBus.$on('getQaAlarm', this.getQaAlarm)
        },
        beforeDestroy() {
            EventBus.$off('getQaAlarm')
        },
        watch: {

        },
        methods: {
            logout() {
                let $this = this
                Swal.fire({
                    title: '',
                    text: '로그아웃 하시겠습니까?',
                    confirmButtonText:  "확인",
                    cancelButtonText: "취소",
                    showCancelButton: true,
                    // showCloseButton: true
                }).then((result) => {
                    if (result.value) {
                        $this.localLogout();
                        $this.$store.dispatch('userInfo/initUserInfo', {info : {}} );
                    } else {

                    }
                });
            },
            handleCommand(command) {
                this[command]()
            },
            getNoticeList() {
                try{
                  this.$api.$custom.getPresentdNotice().then(data => {
                      if(data.Data.hasOwnProperty('Result')) {
                          this.NoticeList = data.Data.Result;
                      }
                  })
                } catch (e) {
                  console.log(e);
                }
            },
            getQaAlarm() {
              try {
                this.$api.$custom.getAlarmQa().then(data => {
                  if(data.Data.hasOwnProperty('Result')) {
                    this.qnaCount = data.Data.Result.List;
                    this.$forceUpdate()
                  }
                });
              } catch (e) {
                console.log(e);
              }
            },
            isMenuPrivileage(route ){
                let User = this.UserInfo.Info;
                if(!route.meta.accessLevel){
                    return true;
                }

                if(route.meta.accessLevel.includes(User.mb_level)){
                    return true;
                }else{
                    return false;
                }


            }
        },
    }
</script>

<style scoped>

</style>
